export class User {
    id: number;
    emailId: any;
    mobileNum: Number;
    username: string;
    password: string;
    role: Role;
}

export enum Role {
    Vendor = 'Vendor',
    SuperAdmin = 'SuperAdmin'
}